import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 明青 (Cyan)
  colorPrimary: '#13C2C2',
  layout: 'top',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  splitMenus: false,
  colorWeak: false,
  // title is set dynamically in app.tsx layout function using i18n
  // title: 'Admin Panel',
  pwa: process.env.NODE_ENV === 'production', // Only enable PWA in production
  // 테스트 빌드는 초록 로고(config.ts 의 ADMIN_LOGO)
  logo: process.env.ADMIN_LOGO || '/logo.png',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
